import animationStyles from './styles/product.videoAnimation.module.scss';
import React from 'react';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
import { dlDispatchAmplEvent } from '../../../../events/dl.dispatchAmplEvent';
import { clsx } from '../../../../utils/clsx';
import { getSrcSetForLazy } from '../../../../utils/getSrcSetForLazy';
import { ppData } from '../../configs/ppData.config';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { FlatPreview } from './FlatPreview';
import { sizesMainImage } from './configs/sizes.mainImage';
export const MainImageDesktop = ({ openPreview, image, isVideo }) => {
    return (React.createElement("button", { className: "pos:r z:1 btn:cleared w:100p image-wrapper bdrs:1 ov:h bg:f4f4f4", onClick: () => {
            if (!MEDIA_BREAKPOINTS.LG_UP.matches)
                return;
            openPreview();
            dlDispatchAmplEvent('Large preview popup', { image: typeof image === 'string' ? image : image.art });
        } },
        React.createElement("span", { className: clsx('d:block pos:a l:0 t:0 h:100p w:100p', isVideo && animationStyles.videoAnimationImage) }, typeof image === 'string'
            ? React.createElement("img", { className: "image:cover", sizes: sizesMainImage, srcSet: getSrcSetForLazy(image, 2376), src: image, height: 702, width: 702, alt: ppData.originalTitle })
            : React.createElement(FlatPreview, { data: image, srcSetMaxSize: 2376, imageAlt: ppData.originalTitle })),
        MEDIA_BREAKPOINTS.LG_UP.matches && !isVideo &&
            React.createElement("span", { className: "pos:a r:14 b:14 r:20:xl-up b:20:xl-up z:2 pev:none bdrs:50p bxsh:2 d:flex ai:center jc:center h:28 w:28 h:36:xl-up w:36:xl-up bg:white" },
                React.createElement(Ssvg, { icon: "#icon--magnifying-plus", className: "h:20 color:text-middle" }))));
};
